import axios from 'axios'
import moment from 'moment'
import { useState } from 'react'
import { constants } from '../../Constants'
import { Button, Modal } from '../ui'
import { useToast } from '../ui/Toast/Toast'

export const ModalRegisterUser = ({ fetchCounts }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [lastname, setLastname] = useState('')
  const [phone, setPhone] = useState('')
  const [price, setPrice] = useState(50)
  const [date, setDate] = useState(() => moment().format('YYYY-MM-DD'))
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()

  const resetFields = () => {
    setEmail('')
    setName('')
    setLastname('')
    setPhone('')
    setPrice(50)
    setDate(moment().format('YYYY-MM-DD'))
  }
  const handleClose = () => {
    resetFields()
    setIsOpen(false)
  }

  const handleSubmit = async () => {
    setIsLoading(true)
    if (!email || !name || !lastname || !date) {
      toast({ title: 'Rellena los campos obligatorios', status: 'warning' })
      setIsLoading(false)
      return
    }
    try {
      const localUser = JSON.parse(localStorage.getItem('user') || 'null')
      // La suscripción activa y el pago del mes de alta se registran en el
      // propio alta (atómico): la fecha elegida aquí es la que se usa de
      // verdad como fecha efectiva del pago, no solo una referencia.
      const response = await axios.post(`${constants.urlLocal}register`, {
        email,
        name,
        lastname,
        phone,
        paymentAmount: price,
        paymentDate: date,
        adminId: localUser?.id,
        adminName: localUser?.name,
        adminLastname: localUser?.lastname,
      })
      if (response.data.ok) {
        toast({ title: 'Usuario registrado correctamente', status: 'success' })
        handleClose()
        fetchCounts()
      } else {
        toast({
          title: 'Error al registrar',
          description: response.data.message,
          status: 'error',
        })
      }
    } catch (error) {
      toast({
        title: 'Error al registrar',
        description: error.response?.data?.message || error.message,
        status: 'error',
      })
    }
    setIsLoading(false)
  }

  return (
    <>
      <Button variant="primary" onClick={() => setIsOpen(true)}>
        👤 Registrar Usuario
      </Button>
      <Modal
        isOpen={isOpen}
        onClose={handleClose}
        title="Registrar Nuevo Usuario"
      >
        <div className="form-group">
          <label className="form-label">Nombre *</label>
          <input
            className="form-input"
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label className="form-label">Apellido *</label>
          <input
            className="form-input"
            value={lastname}
            onChange={e => setLastname(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label className="form-label">Email *</label>
          <input
            className="form-input"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label className="form-label">Teléfono</label>
          <input
            className="form-input"
            type="tel"
            value={phone}
            onChange={e => setPhone(e.target.value)}
          />
        </div>
        <div className="divider" />
        <p
          className="form-label"
          style={{ marginBottom: '0.75rem', color: '#666', fontWeight: 400 }}
        >
          Todo usuario se da de alta con la suscripción activa desde el mes en
          que se registra.
        </p>
        <div className="form-group">
          <label className="form-label">Precio del mes de alta</label>
          <input
            className="form-input"
            type="number"
            value={price}
            onChange={e => setPrice(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label className="form-label">Fecha efectiva del alta</label>
          <input
            className="form-input"
            type="date"
            value={date}
            onChange={e => setDate(e.target.value)}
          />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '0.5rem',
            marginTop: '1rem',
          }}
        >
          <Button variant="ghost" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSubmit} loading={isLoading}>
            Registrar
          </Button>
        </div>
      </Modal>
    </>
  )
}
